import { useTranslation } from 'react-i18next'

import { useDateLocale } from '../../../../../hooks'
import Text from '../../../../Text'
import { QA_NAME_CALENDAR_RELIEVE_DAY_SUBTITLE } from '../../CalendarRelieveDayModal.constants'

import { getCalendarRelieveDaySubtitle } from './DayIntro.utils'

import * as styles from './DayIntro.module.css'

function DayIntro({ day, dayLoad }) {
  const { t } = useTranslation()

  const locale = useDateLocale()

  return (
    <div className={styles.DayIntro}>
      <Text isSecondary qaName={QA_NAME_CALENDAR_RELIEVE_DAY_SUBTITLE}>
        {getCalendarRelieveDaySubtitle({ day, dayLoad, locale })}
      </Text>
      <Text>{t('Calendar.RelieveDayIntroKey')}</Text>
    </div>
  )
}

export default DayIntro
